import { useTheme } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

// Components
import MapleButton from 'Components/ds/MapleButton';
import MapleTypography from 'Components/ds/MapleTypography';
import Banner from 'Components/Banner';
import MaplePopover from 'Components/MaplePopover';
import SidebarNavItem from 'Components/Navigation/SidebarNavItem';

// Constants
import { BANNERS } from 'Components/DesktopBannersCarousel';
import { CIRCLE_TERMS_URL } from 'Constants/index';
import { LEND_ROUTE } from 'Constants/navigation';

// Context
import useBreakpoint from 'Hooks/useBreakpoint';
import { useAnalytics } from 'Hooks/useAnalytics';

// Utils
import { getCircleCountdown } from 'Utils/circle';

const disclaimerStyles = { px: 2, fontSize: '8px', lineHeight: '12px', a: { textDecoration: 'underline' } };

const CircleBanner = ({ onClose }: { onClose: () => void }) => {
  const { analytics } = useAnalytics();
  const { isDesktopDevice, breakPoint } = useBreakpoint();
  const { palette } = useTheme();
  const navigate = useNavigate();

  const handleClose = () => {
    analytics?.track('Syrup - Banner - Circle - Close');
    localStorage.setItem(BANNERS.CIRCLE.storageKey, 'closed');
    onClose();
  };

  const handleOnclick = () => {
    analytics?.track('Syrup - Banner - Circle - Navigate to Lend/Deposit');
    navigate(`${LEND_ROUTE}?asset=usdc&lendInputFocused=true`);
  };

  if (breakPoint === 'lg')
    return (
      <MaplePopover
        copy={['Win up to 300k USDC', 'Deposit at least 1,000 USDC before May 31', 'to be eligible to win!']}
      >
        <SidebarNavItem
          icon='usdc'
          isActive={true}
          onClick={handleOnclick}
          sx={{
            '.badge__inner': {
              backgroundColor: palette.background.white,
            },
          }}
        />
      </MaplePopover>
    );

  return (
    <Banner
      media={
        <video width='100%' autoPlay muted playsInline loop>
          <source src='https://downloads.eth.maple.finance/videos/Modal_Circle_Blue.mp4' type='video/mp4' />
        </video>
      }
      tag={{
        label: getCircleCountdown(),
        color: 'blur',
      }}
      handleClose={handleClose}
      title='Win up to 300,000 USDC'
      description='Deposit over 1,000 USDC before May 31 and have the chance to win prizes from the 500k USDC prize pool!'
      footer={
        <MapleButton
          fullWidth
          variant='contained'
          color='primary'
          size={isDesktopDevice ? 'xSmall' : 'medium'}
          onClick={handleOnclick}
        >
          Deposit
        </MapleButton>
      }
      disclaimer={
        <MapleTypography variant='paragraph' size='xSmall' color='text.soft' sx={disclaimerStyles} textAlign='center'>
          <Link to={CIRCLE_TERMS_URL} target='_blank' rel='noopener noreferrer'>
            Terms & Conditions
          </Link>{' '}
          apply, excludes residents of US and EU.
        </MapleTypography>
      }
    />
  );
};

export default CircleBanner;
